export const templateUrlConfigUty = {
    utymc: './utymc-editPkg.component.html',
    utymd: './utymd-editPkg.component.html',
    utyji05: './utyji05Pkg.component.html',
    utyji05_detail: './utyji05-detailPkg.component.html',
    openwin: './openwin-edit/openwin-edit.component.html',
    utypi02: './utypi02/utypi02BillPkg.component.html',
    //utypi02_detail: './utypi02/utypi02-detailPkg.component.html',
    //utypi03: './utypi03/utypi03BillPkg.component.html',
    //utypi03_detail: './utypi03/utypi03-detailPkg.component.html',
};

export * from './services/utymcPkg.service';
export * from './services/utymc.service';
export * from './services/utymdPkg.service';
export * from './services/utymd.service';
export * from './services/openwin.service';
export * from './services/utysaPkg.service';
export * from './services/utysa.service';
export * from './services/utysb.service';
export * from './services/utysc.service';

